import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => ({
  container: {
    display: 'block',
    margin: 'auto',
    maxWidth: 500,
    textAlign: 'center',
  },
  loading: {
    marginTop: theme.spacing(3.125),
  },
}));
